'use client';

import type { FC } from 'react';
import Img from '@/ui/components/Img/Img';
import Link from '@/ui/components/Link/Link';
import { useGA4 } from '@/ui/context/ga4';

const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=';
const PLAY_STORE_CLICK_TEXT = 'Download Mind Oasis on Google Play';

interface PlayStoreButtonProps {
  appId: string;
  disabled?: boolean;
}

const PlayStoreButton: FC<PlayStoreButtonProps> = ({ appId, disabled }) => {
  const { trackInteraction } = useGA4();
  const href = `${PLAY_STORE_URL}${appId}`;
  const content = (
    <>
      <span className="sr-only">{PLAY_STORE_CLICK_TEXT}</span>
      <Img
        src="/images/play-store-button.png"
        alt=""
        width={155}
        height={45}
      />
    </>
  );

  if (disabled) {
    return <span aria-disabled="true">{content}</span>;
  }

  return (
    <Link
      href={href}
      isExternal
      ariaLabel={PLAY_STORE_CLICK_TEXT}
      onClick={() =>
        trackInteraction({
          interaction_type: 'hyperlink',
          click_target: href,
          click_text: PLAY_STORE_CLICK_TEXT,
          content_name: 'app_download',
        })
      }
    >
      {content}
    </Link>
  );
};

export default PlayStoreButton;
